import React, {Component} from 'react';
import styled from "styled-components";
import PropTypes from 'prop-types';

import ReactSlider from 'react-slider'

const SliderWrapper = styled.div`
    margin: 0.25rem;
    overflow: hidden;
`;

const StyledSlider = styled(ReactSlider)`
    vertical-align: middle;
    height: 1rem;
    width: inherit;
`;

const StyledThumb = styled.div`
    height: 1rem;
    line-height: 1rem;
    text-align: center;
    font-size: 0.85rem;
    background-color: #333;
    color: #fff;
    cursor: grab;
    padding: 0 0.5rem;
`;

const StyledTrack = styled.div`
    top: 0;
    bottom: 0;
    background-color: ${props => props.index === 2 ? '#f00' : props.index === 1 ? '#ddd' : '#888'};
    border-radius: 0.25rem;
`;

const SliderLabel = styled.div`
    display:inline-block;
    font-weight: bold;
    vertical-align: middle;
    padding: 0 0.25rem;    
    text-align: right;
`;

export class ControlSlider extends Component {

    static propTypes = {
        min: PropTypes.number.isRequired,
        max: PropTypes.number.isRequired,
        label: PropTypes.string.isRequired,
        onChange: PropTypes.func.isRequired,
        value: PropTypes.number.isRequired,
        width_container_px: PropTypes.number.isRequired
    }

    state = {}

    render() {
        const Thumb = (props, state) => <StyledThumb {...props}>{state.valueNow}</StyledThumb>;
        const Track = (props, state) => <StyledTrack {...props} index={state.index}/>;
        const slider_style = {
            width: this.props.width_container_px * 0.68 + "px",
            display: "inline-block",
            verticalAlign: "middle"
        };
        const label_style = {
            width: this.props.width_container_px * 0.20 + "px",
            fontSize: this.props.width_container_px * 0.035 + "px"
        };
        return <SliderWrapper>
            <SliderLabel style={label_style}>{this.props.label}:</SliderLabel>
            <div style={slider_style}>
                <StyledSlider
                    max={this.props.max}
                    min={this.props.min}
                    defaultValue={this.props.value}
                    renderTrack={Track}
                    renderThumb={Thumb}
                    onChange={this.props.onChange}
                />
            </div>
        </SliderWrapper>
    }
}

export default ControlSlider;
